import { getToken } from '../../utils/auth';
import apiFetch from '../core/apiFetch';
import { checkStatus, handleError } from '../../utils/api';
import {
  EligibilityCheck,
  EligibilityCheckApi,
} from '../../interfaces/register';
import { formatDate } from '../../utils/shared/normalize';

const mapToApi = (values: EligibilityCheck): EligibilityCheckApi => {
  return {
    affiliation_id: values.affiliationId,
    dependent: values.isDependent,
    member_id: values.memberId,
    primary_first_name: values.primaryFirstName,
    primary_last_name: values.primaryLastName,
    primary_gender: values.primaryGender,
    primary_member_id: values.primaryMemberId,
    primary_birthdate:
      values.primaryDobDay &&
      values.primaryDobMonth &&
      values.primaryDobYear &&
      formatDate(
        `${values.primaryDobMonth}/${values.primaryDobDay}/${values.primaryDobYear}`,
        'iso'
      ),
    relationship: values.relationship,
  };
};

const postEligibilityCheckAsync = async (values: EligibilityCheck) => {
  const url = `api/v2/eligibility_check`;

  try {
    const token = getToken();
    const response = await apiFetch(token, url, {
      method: 'POST',
      body: JSON.stringify({ eligibility_check: mapToApi(values) }),
    });

    await checkStatus(response);

    const { eligibility_check: eligibilityCheck } = await response.json();
    return { error: null, eligibilityCheck };
  } catch (error) {
    handleError('unexpected status - v2 eligibility check', error);
    return { error: true, eligibilityCheck: null };
  }
};

export default postEligibilityCheckAsync;
